import React from "react";

//#region CSS
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#aba3a3",
    color: theme.palette.common.white,
    fontSize: "1.10rem"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);
const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    display: "flex",
    textAlign: "justify"
  }
}));
//#endregion

export default function Example(props) {
  const classes = useStyles();
  console.log('Politica de Cookies - RRLL 8.0')
  return (
    <div className={classes.root}>
      <Grid container justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid container justify="center" alignItems="center" item xs={12}>
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography color="secondary" variant="h4" data-lang="cookies_title">
                  <u>POLÍTICA DE COOKIES</u>
                </Typography>
              </Box>
            </Grid>
            <Grid
              container
              item xs={11} lg={9} className="mt-3"
            >
              <Grid item xs={12}>
                <p data-lang-html="cookies_intro">
                  SOLERA 1900, S.L. tiene como objetivo respetar la privacidad de sus usuarios y proteger los datos de carácter personal que éstos puedan facilitar a SOLERA 1900, S.L. y/o que las cookies puedan obtener.
                </p>
                <p data-lang-html="cookies_commitment">
                  En el presente documento se encuentra toda la información sobre las cookies que utilizamos. Como muestra de compromiso con la normativa de protección de datos, SOLERA 1900, S.L. pone a disposición del usuario, de manera permanente, la información relativa a nuestra política de cookies.
                </p>
                <div style={{ padding: "10px", border: "solid 1px", margin: "10px 0" }}>
                  SOLERA 1900, S.L. (en adelante, ILUSIONA)<br />
                  NIF: B-63.294.565<br />
                  Calle General Diaz Porlier, 14, Bajos, Puerta 3ª<br />
                  Madrid (28001 - Madrid)<br />
                  <a href="https://club.ilusiona.com" target="_blank" rel="noopener noreferrer">club.ilusiona.com</a>
                </div>
              </Grid>
              <Grid item xs={12}>
                <p data-lang-html="cookies_what_are_title">
                  <strong>
                    <u>
                      ¿Qué son las cookies?
                    </u>
                  </strong>
                </p>
                <p data-lang-html="cookies_what_are_p1">
                  Una cookie es un pequeño archivo que se almacena en el dispositivo del usuario con información sobre la navegación.
                </p>
                <p data-lang-html="cookies_what_are_p2">
                  Se informa al usuario que este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando se navega. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación, personalizar la forma en que se muestra el contenido, el idioma de navegación del usuario, el país, el inicio de sesión, las características del navegador, o incluso información acerca de la fecha y hora de la última visita, parámetros de tráfico dentro de la website y el número de visitas.
                </p>
                <p data-lang-html="cookies_what_are_p3">
                  Los usos concretos que hacemos de estas tecnologías se describen en la tabla de cookies contenidas en la presente política.
                 </p>
                <p data-lang-html="cookies_types_title">
                  <strong>
                    <u>
                      ¿Qué tipos de cookies existen?
                    </u>
                  </strong>
                </p>
                <p>
                  <strong data-lang-html="cookies_types_by_purpose">
                    Según su finalidad:
                  </strong>
                </p>
                <ul data-lang-html="cookies_types_technical">
                  <li>Técnicas: Son aquellas necesarias para la navegación y el buen funcionamiento de la página web. Permiten, por ejemplo, controlar el tráfico y la comunicación de datos, acceder a partes de acceso restringido, realizar el proceso de compra de un pedido, utilizar elementos de seguridad, etc.. Esta cookie no requiere del consentimiento del usuario para su instalación, según lo establecido en la Guía de Cookies de la Agencia Española de Protección de Datos y la normativa vigente.</li>
                  <li>Personalización: Son aquellas que permiten acceder al servicio con unas características predefinidas en función de una serie de criterios, como por ejemplo el idioma, el tipo de navegador a través del cual se accede al servicio, la configuración regional desde donde se accede al servicio, etc. Esta cookie no requiere del consentimiento del usuario para su instalación, según lo establecido en la Guía de Cookies de la Agencia Española de Protección de Datos y la normativa vigente.</li>
                  <li>De análisis: son aquellas que permiten cuantificar el número de usuarios para realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofrecido. Para ello se analiza la navegación del usuario en la página web con el fin de mejorar la oferta de productos o servicios ofrecidos.</li>
                  <li>Publicitarias comportamentales: son aquellas que almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</li>
                  <li>Publicitarias: Estas cookies permiten la gestión de los espacios publicitarios incluidos en la presente website, como, por ejemplo, la frecuencia en la que se muestran los anuncios.</li>
                </ul>
                <p>
                  <strong data-lang-html="cookies_types_by_duration">
                    Según el plazo de tiempo en que permanezcan activas:
                  </strong>
                </p>
                <ul>
                  <li>Cookies de sesión: Son cookies temporales que permanecen en el archivo de cookies del navegador hasta que se abandona la página web, por lo que ninguna queda registrada en la memoria del dispositivo. La información obtenida por medio de estas cookies sirve para analizar pautas de tráfico en la web. A la larga, permite proporcionar una mejor experiencia para mejorar el contenido y facilitar su uso. Podrá identificar las cookies de sesión en la tabla recogida en la presente política, bajo el título "Al finalizar la sesión de navegación".</li>
                  <li>Cookies persistentes: Son almacenadas en el dispositivo y la página web las lee cada vez que se realiza una nueva visita. Una cookie permanente posee una fecha de expiración determinada, pudiendo variar según la funcionalidad de para la que haya sido asignada. La cookie dejará de funcionar después de esa fecha. Podrá ver la información relativa a la duración de las cookies persistentes en la tabla recogida en la presente política.</li>
                </ul>
                <p>
                  <strong data-lang-html="cookies_types_by_manager">
                    Según quién las gestiona:
                  </strong>
                </p>
                <ul>
                  <li>Cookies propias: Son aquellas cookies que se almacenan en el dispositivo del usuario por nuestros equipos o dominios y desde el cual se presta el servicio oportuno de la página web.</li>
                  <li>Cookies de terceros: Son aquellas cookies que se almacenan en los dispositivos del usuario y que no son gestionados por ILUSIONA, sino por un tercero colaborador. A modo de ejemplo, son aquellas cookies utilizadas por redes sociales, visionados de video o por la información facilitada por Google Maps para localizarnos.</li>
                </ul>
                <p data-lang-html="cookies_third_party_note">
                  Tenga en cuenta que, si acepta las cookies de terceros, deberá eliminarlas desde las opciones del navegador o desde el sistema ofrecido por el propio tercero.
                </p>
                <p data-lang-html="cookies_who_uses_title">
                  <strong>
                    <u>
                      ¿Quién utiliza la información almacenada en las Cookies?
                    </u>
                  </strong>
                </p>
                <p data-lang-html="cookies_who_uses_content">
                  ILUSIONA utiliza la información almacenada en las cookies de la presente website exclusivamente para nosotros, salvo aquellas cookies identificadas más adelante como gestionadas por "Terceros", que son utilizadas y gestionadas por entidades externas para proporcionarnos servicios solicitados por nosotros, a fin de ayudarnos a mejorar nuestros servicios, así como la experiencia del usuario al utilizar nuestra website. En el siguiente apartado, se especifican el tipo de cookies utilizadas por terceros.
                </p>
                <p data-lang-html="cookies_retention_title">
                  <strong><u>
                    ¿Cuánto tiempo conservamos la información recabada con las cookies?
                  </u></strong>
                </p>
                <p data-lang-html="cookies_retention_content">
                  Los datos de carácter personal serán conservados hasta que permanezcan vigentes las autorizaciones otorgadas por el usuario o hasta que expire el tiempo de funcionalidad de la cookie, de acuerdo con la normativa de protección de datos y la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico. Puede consultar la tabla en la que se detallan las cookies utilizadas en la presente website para conocer más sobre la conservación de la información recabada.
                </p>
                <p data-lang-html="cookies_legal_basis_title">
                  <strong><u>
                    ¿Cuál es la base jurídica de la gestión de las cookies?
                  </u></strong>
                </p>
                <p data-lang-html="cookies_legal_basis_content">
                  La base jurídica del tratamiento es el consentimiento, pudiéndose gestionar y/o revocar según las indicaciones contenidas en el presente documento.
                </p>
                <p data-lang-html="cookies_which_title">
                  <strong><u>
                    ¿Qué cookies en concreto utiliza esta website y para qué finalidades?
                  </u></strong>
                </p>
                <p data-lang-html="cookies_which_intro">
                  ILUSIONA, a través de la presente website, utiliza las siguientes cookies:
                </p>
                <br />
                <TableContainer component={Paper}>
                  <Table
                    className={classes.table}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Nombre</StyledTableCell>
                        <StyledTableCell>Finalidad</StyledTableCell>
                        <StyledTableCell>Descripción</StyledTableCell>
                        <StyledTableCell>Propiedad</StyledTableCell>
                        <StyledTableCell>Duración</StyledTableCell>
                        <StyledTableCell>Transferencia internacional</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell>_ga</StyledTableCell>
                        <StyledTableCell>Analítica</StyledTableCell>
                        <StyledTableCell>
                          Cookie utilizada para distinguir usuarios.
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Trece meses</StyledTableCell>
                        <StyledTableCell>Sí. +info <a href="https://policies.google.com/privacy/frameworks?hl=es" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy/frameworks?hl=es</a></StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell>_ga_4JW3RKXXV7</StyledTableCell>
                        <StyledTableCell>Analítica</StyledTableCell>
                        <StyledTableCell>
                          Cookie utilizada para distinguir usuarios.
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Trece meses</StyledTableCell>
                        <StyledTableCell>Sí. +info <a href="https://policies.google.com/privacy/frameworks?hl=es" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy/frameworks?hl=es</a></StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell>_ga_Q318EZG0N8</StyledTableCell>
                        <StyledTableCell>Analítica</StyledTableCell>
                        <StyledTableCell>
                          Cookie utilizada para distinguir usuarios.
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Trece meses</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell>_gid</StyledTableCell>
                        <StyledTableCell>Analítica</StyledTableCell>
                        <StyledTableCell>
                          Cookie utilizada para distinguir usuarios
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Un día</StyledTableCell>
                        <StyledTableCell>Sí. +info <a href="https://policies.google.com/privacy/frameworks?hl=es" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy/frameworks?hl=es</a></StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell>_gat_gtag_UA_59807770_1</StyledTableCell>
                        <StyledTableCell>Analítica</StyledTableCell>
                        <StyledTableCell>
                          Cookie utilizada para limitar el porcentaje de solicitudes.
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Un minuto</StyledTableCell>
                        <StyledTableCell>Sí. +info <a href="https://policies.google.com/privacy/frameworks?hl=es" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy/frameworks?hl=es</a></StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell>ARRAffinitySameSite</StyledTableCell>
                        <StyledTableCell>Técnica</StyledTableCell>
                        <StyledTableCell>
                          Este atributo SameSite permite que los navegadores reduzcan el riesgo de fuga de información y, en consecuencia, mejorará la protección de ataques cross-site mediante peticiones falsas.
                        </StyledTableCell>
                        <StyledTableCell>ILUSIONA</StyledTableCell>
                        <StyledTableCell>Al finalizar la sesión de navegación</StyledTableCell>
                        <StyledTableCell>Sí. +info <a href="https://azure.microsoft.com/es-es/explore/trusted-cloud/privacy" target="_blank" rel="noopener noreferrer">https://azure.microsoft.com/es-es/explore/trusted-cloud/privacy</a></StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12}>
                <br />
                <p data-lang-html="cookies_transfer_title">
                  <strong><u>
                    ¿Se transfieren cookies a terceros países?
                  </u></strong>
                </p>
                <p data-lang-html="cookies_transfer_content">
                  Con carácter general, las cookies utilizadas no se transfieren a países ubicados fuera del Espacio Económico Europeo. En algunos casos, es posible que se realicen transferencias de datos por prestadores de servicios ubicados fuera del Espacio Económico Europeo, pero respetando las garantías adecuadas, según lo establecido en el artículo 46.2 del Reglamento General de Protección de Datos de la Unión Europea (RGPD) y siempre guardando la seguridad de tus datos, proporcionando un nivel de protección equiparable al de la Unión Europea.
                </p>
                <p data-lang-html="cookies_transfer_third_party">
                  Para las cookies utilizadas por terceros, puede consultar su política de cookies en la tabla de cookies especificada en el presente documento.
                </p>
                <p data-lang-html="cookies_disable_title">
                  <strong><u>
                    ¿Cómo desactivar las cookies?
                  </u></strong>
                </p>
                <p data-lang-html="cookies_disable_p1">
                  Al acceder a la website, el usuario verá un aviso de cookies en el que se le informará de la forma en la que puede consentir o rechazar la instalación de las mismas.
                </p>
                <p data-lang-html="cookies_disable_p2">
                  Asimismo, el usuario, en todo momento, podrá deshabilitar o eliminar las cookies utilizadas en la presente website a través de la configuración del navegador que utilice en su dispositivo. A continuación, le proporcionamos información acerca de cómo activar y desactivar las cookies en los principales navegadores web:
                </p>
                <ul>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.google.com/chrome/answer/95647?hl=es">
                      Configuración de cookies para Google Chrome
                    </a>
                  </li>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform=Android&hl=es">
                      Configuración de cookies para Google Android
                    </a>
                  </li>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-?redirectlocale=en-US&redirectslug=Cookies">
                      Configuración de cookies para Mozilla Firefox
                    </a>
                  </li>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.apple.com/es-es/HT201265">
                      Configuración de cookies para Safari
                    </a>
                  </li>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.apple.com/es-es/HT201265">
                      Configuración de cookies para IOS (iPhone e iPad)
                    </a>
                  </li>
                  <li style={{ paddingBottom: "10px" }}>
                    <a href="https://support.microsoft.com/es-es/help/4468242/microsoft-edge-browsing-data-and-privacy#:~:text=Para%20borrar%20la%20informaci%C3%B3n%20de,lo%20que%20se%20debe%20borrar.">
                      Configuración de cookies para Microsoft Edge
                    </a>
                  </li>
                </ul>
                <p data-lang-html="cookies_disable_p3">
                  El usuario debe tener en cuenta que algunas de las características de los contenidos de la website sólo están disponibles si se permite la instalación de cookies, por lo que se informa al usuario que la ausencia de cookies, su bloqueo o la limitación en su instalación, podrían provocar que algunas de las características de la website no funcionen o puedan resultar más complicadas o lentas de acceder.
                </p>
                <p data-lang-html="cookies_disable_p4">
                  Informar que es posible que el sistema de gestión de cookies facilitado para la aceptación, rechazo o configuración de las cookies no permita la utilización de cookies de terceros. En este sentido, si se aceptan cookies de terceros y posteriormente se desean eliminar, se deberá realizar desde el propio navegador, según las especificaciones detalladas en los enlaces facilitados en el presente apartado.
                </p>
                <p data-lang-html="cookies_rights_title">
                  <strong><u>
                    Derechos de los usuarios
                  </u></strong>
                </p>
                <p data-lang-html="cookies_rights_intro">
                  Los usuarios disponen de los siguientes derechos en materia de protección de datos:
                </p>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                  <tbody>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center', width: '30%' }}>
                        DERECHO DE ACCESO
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tiene derecho a obtener de ILUSIONA confirmación de si se están tratando o no datos de carácter personal que le conciernen, así como a acceder a los datos personales que ILUSIONA disponga.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO DE RECTIFICACIÓN
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tiene derecho a solicitar que ILUSIONA rectifique los datos inexactos que le conciernen. También tendrá derecho a que se completen los datos personales que sean incompletos, inclusive mediante una declaración adicional.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO DE SUPRESIÓN/DERECHO AL OLVIDO
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tendrá derecho a que ILUSIONA suprima los datos personales que le conciernen, siempre teniendo en cuenta los requisitos establecidos en la legislación vigente.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO DE LIMITACIÓN
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tendrá derecho a solicitar a ILUSIONA la limitación del tratamiento de los datos personales, siempre teniendo en cuenta los requisitos establecidos en la legislación vigente.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO DE PORTABILIDAD
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tendrá derecho a recibir de ILUSIONA los datos personales que le incumban en un formato estructurado, de uso común y lectura mecánica, y a transmitirlos a otro responsable cuando el tratamiento se base en el consentimiento o en un contrato, y se efectúe por medios automatizados.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO DE OPOSICIÓN
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tiene derecho a oponerse a que ILUSIONA trate los datos personales que le conciernen cuando estos sean objeto de un tratamiento basado en el interés público o legítimo. En tal caso, ILUSIONA dejará de tratar los datos, salvo por motivos legítimos imperiosos o el ejercicio o defensa de posibles reclamaciones.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DECISIONES INDIVIDUALES AUTOMATIZADAS
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tendrá derecho a no ser objeto de decisiones basadas únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que produzca efectos jurídicos en él o afecte significativamente de modo similar, siempre teniendo en cuenta los requisitos establecidos en la legislación vigente, si fuera el caso.
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: '#B8CCE4', padding: '10px', border: '1px solid #000', fontWeight: 'bold', textAlign: 'center' }}>
                        DERECHO A PRESENTAR UNA RECLAMACIÓN
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #000', textAlign: 'justify' }}>
                        El usuario tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos si considera que se vulneran los derechos anteriormente expuestos en la presente política de privacidad o si considera que el tratamiento de datos personales que le conciernen infringe el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales.
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p data-lang-html="cookies_rights_exercise">
                  El usuario o su representante, legal o voluntario, acreditando su identidad, así como el poder de representación oportuno, podrán ejercer los derechos descritos anteriormente dirigiendo una comunicación por escrito a la dirección de correo electrónico <a href="mailto:rgpd@ilusiona.com">rgpd@ilusiona.com</a>.
                </p>
                <p data-lang-html="cookies_minors_title">
                  <strong><u>
                    Menores de edad
                  </u></strong>
                </p>
                <p data-lang-html="cookies_minors_p1">
                  Los menores de 14 años no podrán usar los servicios disponibles en la presente website sin la previa autorización de sus padres, tutores o representantes legales, quienes serán los únicos responsables de todos los actos realizados a través de esta website por los menores a su cargo, incluyendo la cumplimentación de los formularios con los datos personales de dichos menores y la marcación, en su caso, de las casillas que los acompañan.
                </p>
                <p data-lang-html="cookies_minors_p2">
                  En este sentido, y en la medida en que ILUSIONA no tiene capacidad para controlar si los usuarios son o no menores de edad, deberán ser los padres, tutores o representantes legales quienes habiliten los mecanismos necesarios para evitar que los menores accedan a esta website y/o faciliten datos de carácter personal sin su supervisión, no admitiendo ILUSIONA responsabilidad alguna al respecto.
                </p>
                <p data-lang-html="cookies_changes_title">
                  <strong><u>
                    Cambios en la política de cookies
                  </u></strong>
                </p>
                <p data-lang-html="cookies_changes_p1">
                  La presente política de cookies podrá ser actualizada en cualquier momento en base a las necesidades propias de la website y futuros cambios legislativos en materia de privacidad, reservándose ILUSIONA este derecho en exclusiva.
                </p>
                <p data-lang-html="cookies_changes_p2">
                  En caso de realizarse dicha modificación, ILUSIONA informará al usuario de los cambios en cuestión si son significativos para su privacidad, de manera que se puedan revisar los cambios introducidos, a fin de valorar el otorgamiento oportuno. En cualquier caso, si se requiere el consentimiento para la gestión de la cookie, se solicitará el consentimiento al usuario según las previsiones de la normativa relativa a protección de datos vigente en cada momento.
                </p>
                <p data-lang-html="cookies_changes_p3">
                  Para más información, ILUSIONA recomienda la lectura de la sección de ayuda del navegador.
                </p>
                <br />
                <p data-lang-html="cookies_thanks">¡Muchas gracias y disfruta de la navegación!</p>
                <br />
                <p data-lang-html="cookies_last_update"><strong>Última modificación:</strong> 17 de octubre de 2024</p>
                <br />
                <p data-lang-html="cookies_legal_text">
                  <strong>Texto legal desarrollado por:</strong><br />
                  Área Digital Abogados, S.L.P.<br />
                  <a href="https://adabogados.net" target="_blank" rel="noopener noreferrer">adabogados.net</a>
                </p>
                <br />
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div >
  );
}